export default {
      id: "shop-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#shop",
      toString: function () {
        return this.url;
      }
    }